import {z} from 'zod';

export const PersonSchema = z.object({
	id: z.string(),
	name: z.string(),
	avatarUrl: z.string().nullable(),
});

export type IPerson = z.infer<typeof PersonSchema>;

export const PersonField = PersonSchema.keyof().enum;
